<template>
  <div class="coordinator-dashboard pa-10">

    <!-- ── Header ── -->
    <div class="d-flex flex-wrap justify-space-between align-center mb-7 gap-3">
      <div>
        <div class="dash-page-title">Coordinator Dashboard</div>
        <div class="dash-page-sub mt-1">
          OJT Program Management &amp; Student Deployment
        </div>
      </div>
      <v-btn
        color="#10b981"
        variant="flat"
        prepend-icon="mdi-download-outline"
        class="text-white"
        rounded="lg"
        size="large"
      >
        Generate Reports
      </v-btn>
    </div>

    <!-- ── Stat Cards ── -->
    <v-row class="mb-5" style="gap: 0;">
      <v-col cols="12" sm="6" lg="3">
        <div class="stat-card stat-card--amber rounded-xl pa-5">
          <div class="d-flex justify-space-between align-start mb-4">
            <div class="stat-icon-box stat-icon-box--amber rounded-lg pa-2">
              <v-icon size="22" color="#d97706">mdi-clock-outline</v-icon>
            </div>
            <v-icon size="18" color="#d97706">mdi-trending-up</v-icon>
          </div>
          <div class="stat-number stat-number--amber">30</div>
          <div class="stat-label stat-label--amber">For Matching</div>
          <div class="stat-sub">Awaiting job matching</div>
        </div>
      </v-col>

      <v-col cols="12" sm="6" lg="3">
        <div class="stat-card stat-card--purple rounded-xl pa-5">
          <div class="d-flex justify-space-between align-start mb-4">
            <div class="stat-icon-box stat-icon-box--purple rounded-lg pa-2">
              <v-icon size="22" color="#7c3aed">mdi-send-outline</v-icon>
            </div>
            <v-icon size="18" color="#7c3aed">mdi-trending-up</v-icon>
          </div>
          <div class="stat-number stat-number--purple">45</div>
          <div class="stat-label stat-label--purple">Endorsed</div>
          <div class="stat-sub">Pending HTE acceptance</div>
        </div>
      </v-col>

      <v-col cols="12" sm="6" lg="3">
        <div class="stat-card stat-card--green rounded-xl pa-5">
          <div class="d-flex justify-space-between align-start mb-4">
            <div class="stat-icon-box stat-icon-box--green rounded-lg pa-2">
              <v-icon size="22" color="#059669">mdi-account-check-outline</v-icon>
            </div>
            <v-icon size="18" color="#059669">mdi-check-circle-outline</v-icon>
          </div>
          <div class="stat-number stat-number--green">120</div>
          <div class="stat-label stat-label--green">Deployed</div>
          <div class="stat-sub">Currently in training</div>
        </div>
      </v-col>

      <v-col cols="12" sm="6" lg="3">
        <div class="stat-card stat-card--blue rounded-xl pa-5">
          <div class="d-flex justify-space-between align-start mb-4">
            <div class="stat-icon-box stat-icon-box--blue rounded-lg pa-2">
              <v-icon size="22" color="#2563eb">mdi-office-building-outline</v-icon>
            </div>
            <v-icon size="18" color="#2563eb">mdi-trending-up</v-icon>
          </div>
          <div class="stat-number stat-number--blue">42</div>
          <div class="stat-label stat-label--blue">Partner HTEs</div>
          <div class="stat-sub">Active partnerships</div>
        </div>
      </v-col>
    </v-row>

    <!-- ── Charts Row 1 ── -->
    <v-row class="mb-5">
      <v-col cols="12" md="6">
        <div class="dash-card rounded-xl pa-6">
          <div class="d-flex justify-space-between align-center mb-1">
            <div class="card-title">Student Deployment Overview</div>
            <v-icon size="20" color="#94a3b8">mdi-account-group-outline</v-icon>
          </div>
          <div class="card-sub mb-5">Current matching and placement status</div>
          <div class="chart-wrap chart-wrap--doughnut">
            <canvas ref="deploymentChart"></canvas>
          </div>
        </div>
      </v-col>
      <v-col cols="12" md="6">
        <div class="dash-card rounded-xl pa-6">
          <div class="d-flex justify-space-between align-center mb-1">
            <div class="card-title">Cumulative Training Hours</div>
            <v-icon size="20" color="#94a3b8">mdi-clock-outline</v-icon>
          </div>
          <div class="card-sub mb-5">Total hours logged across all students</div>
          <div class="chart-wrap">
            <canvas ref="trainingHoursChart"></canvas>
          </div>
        </div>
      </v-col>
    </v-row>

    <!-- ── Charts Row 2 ── -->
    <v-row class="mb-5">
      <v-col cols="12" md="6">
        <div class="dash-card rounded-xl pa-6">
          <div class="d-flex justify-space-between align-center mb-1">
            <div class="card-title">Requirements Submission</div>
            <v-icon size="20" color="#94a3b8">mdi-file-document-outline</v-icon>
          </div>
          <div class="card-sub mb-5">Document completion by program</div>
          <div class="chart-wrap">
            <canvas ref="requirementsChart"></canvas>
          </div>
        </div>
      </v-col>
      <v-col cols="12" md="6">
        <div class="dash-card rounded-xl pa-6">
          <div class="d-flex justify-space-between align-center mb-1">
            <div class="card-title">Average Evaluation Scores</div>
            <v-icon size="20" color="#94a3b8">mdi-star-outline</v-icon>
          </div>
          <div class="card-sub mb-5">Performance ratings from industry supervisors</div>
          <div class="chart-wrap">
            <canvas ref="evaluationChart"></canvas>
          </div>
        </div>
      </v-col>
    </v-row>

    <!-- ── Quick Report Generation ── -->
    <div class="dash-card rounded-xl pa-6 mb-5">
      <div class="d-flex justify-space-between align-center mb-5">
        <div class="card-title">Quick Report Generation</div>
        <a class="view-all-link">View All Reports →</a>
      </div>
      <v-row>
        <v-col cols="12" sm="4">
          <div class="report-card report-card--active rounded-xl pa-5">
            <v-icon color="#059669" size="26" class="mb-3">mdi-account-multiple-outline</v-icon>
            <div class="report-title">Student Practicum Profile</div>
            <div class="report-sub">Master list of all OJT students</div>
          </div>
        </v-col>
        <v-col cols="12" sm="4">
          <div class="report-card rounded-xl pa-5">
            <v-icon color="#6b7280" size="26" class="mb-3">mdi-clock-outline</v-icon>
            <div class="report-title">OJT Hours Monitoring</div>
            <div class="report-sub">Track student training hours</div>
          </div>
        </v-col>
        <v-col cols="12" sm="4">
          <div class="report-card rounded-xl pa-5">
            <v-icon color="#6b7280" size="26" class="mb-3">mdi-office-building-outline</v-icon>
            <div class="report-title">HTE Directory</div>
            <div class="report-sub">Partner companies database</div>
          </div>
        </v-col>
      </v-row>
    </div>

    <!-- ── Critical Alerts ── -->
    <div class="dash-card rounded-xl pa-6">
      <div class="d-flex align-center gap-4 mb-5">
        <v-icon color="#f59e0b" size="20">mdi-alert-outline</v-icon>&nbsp;
        <div class="card-title">Critical Alerts &amp; Action Items</div>
      </div>

      <div class="alert-item rounded-xl pa-4 mb-3" style="background: #fff7ed; border: 1px solid #fed7aa">
        <div class="d-flex align-start" style="gap: 16px;">
          <div class="alert-icon-box rounded-lg pa-2" style="background: #fde8cc">
            <v-icon color="#ea580c" size="20">mdi-calendar-alert</v-icon>
          </div>
          <div>
            <div class="alert-title">8 MOAs Expiring Soon</div>
            <div class="alert-desc">Partnership agreements require renewal within 30 days</div>
            <a class="alert-link" style="color: #ea580c">View Details</a>
          </div>
        </div>
      </div>

      <div class="alert-item rounded-xl pa-4 mb-3" style="background: #fefce8; border: 1px solid #fef08a">
        <div class="d-flex align-start" style="gap: 16px;">
          <div class="alert-icon-box rounded-lg pa-2" style="background: #fef3c7">
            <v-icon color="#ca8a04" size="20">mdi-account-multiple-outline</v-icon>
          </div>
          <div>
            <div class="alert-title">30 Students Awaiting Matching</div>
            <div class="alert-desc">Students need to be matched with partner companies</div>
            <a class="alert-link" style="color: #ca8a04">Go to Matching</a>
          </div>
        </div>
      </div>

      <div class="alert-item rounded-xl pa-4" style="background: #eff6ff; border: 1px solid #bfdbfe">
        <div class="d-flex align-start" style="gap: 16px;">
          <div class="alert-icon-box rounded-lg pa-2" style="background: #dbeafe">
            <v-icon color="#2563eb" size="20">mdi-file-document-outline</v-icon>
          </div>
          <div>
            <div class="alert-title">18 Documents Pending Review</div>
            <div class="alert-desc">Student requirements awaiting validation</div>
            <a class="alert-link" style="color: #2563eb">Review Documents</a>
          </div>
        </div>
      </div>
    </div>

    <!-- Recent Activity -->
    <v-row class="mb-5 mt-5">
      <v-col cols="12">
        <div class="dash-card rounded-xl pa-6">
          <div class="d-flex justify-space-between align-center mb-5">
            <div>
              <div class="card-title">Recent Activity</div>
              <div class="card-sub">Latest system events</div>
            </div>
            <router-link :to="`/${currentUserPath}/activity-log`" class="activity-view-all-link">View All →</router-link>
          </div>
          <div v-if="activityLoading" class="d-flex justify-center py-6">
            <v-progress-circular indeterminate color="#10b981" size="32" />
          </div>
          <div v-else-if="!recentActivity.length" class="text-center py-6" style="color: #9ca3af; font-size: 13px">
            No recent activity
          </div>
          <div v-else>
            <div
              v-for="(item, idx) in recentActivity"
              :key="idx"
              class="activity-item rounded-xl pa-4"
              :class="idx < recentActivity.length - 1 ? 'mb-3' : ''"
              :style="getActivityBadgeStyle(item.action)"
            >
              <div class="d-flex align-start ga-3">
                <div class="activity-icon-box rounded-lg pa-2 flex-shrink-0" :style="{ background: getActivityConfig(item.action).iconBg }">
                  <v-icon :color="getActivityColor(item.action)" size="18">{{ getActivityIcon(item.action) }}</v-icon>
                </div>
                <div class="flex-grow-1">
                  <div class="d-flex justify-space-between align-start">
                    <div class="activity-title">{{ item.description || item.action }}</div>
                    <v-chip size="x-small" :color="getActivityColor(item.action)" variant="tonal" class="ml-2 flex-shrink-0">{{ getActivityConfig(item.action).label }}</v-chip>
                  </div>
                  <div class="activity-desc">By {{ item.performed_by_name || 'System' }}</div>
                  <div class="activity-time">{{ formatActivityTime(item.created_at) }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>

  </div>
</template>

<script>
import Chart from "chart.js/auto";
export default {
  name: "DashboardPage",
  data() {
    return {
      charts: {},
      recentActivity: [],
      activityLoading: false,
    };
  },
  computed: {
    currentUserPath() {
      return this.$route.path.split('/')[1];
    },
    getUser() {
      if (this.$store.state.user.user.usertypeID != 7) {
        return this.$store.state.user.fname;
      }
      return this.$store.state.user.name;
    },
    getCurrentDate() {
      return new Date().toLocaleDateString("en-US", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },
  },
  mounted() {
    this.fetchRecentActivity();
    this.$nextTick(() => {
      this.initDeploymentChart();
      this.initTrainingHoursChart();
      this.initRequirementsChart();
      this.initEvaluationChart();
    });
  },
  beforeUnmount() {
    Object.values(this.charts).forEach((c) => c && c.destroy());
  },
  methods: {
    initDeploymentChart() {
      this.charts.deployment = new Chart(this.$refs.deploymentChart, {
        type: "doughnut",
        data: {
          labels: ["For Matching", "Endorsed", "Deployed"],
          datasets: [
            {
              data: [30, 45, 120],
              backgroundColor: ["#fbbf24", "#8b5cf6", "#10b981"],
              borderWidth: 3,
              borderColor: "#fff",
              hoverOffset: 6,
            },
          ],
        },
        options: {
          cutout: "72%",
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              position: "bottom",
              labels: {
                usePointStyle: true,
                pointStyle: "circle",
                padding: 20,
                font: { size: 12 },
                color: "#6b7280",
              },
            },
          },
        },
      });
    },

    initTrainingHoursChart() {
      this.charts.trainingHours = new Chart(this.$refs.trainingHoursChart, {
        type: "line",
        data: {
          labels: ["Sep", "Oct", "Nov", "Dec", "Jan", "Feb"],
          datasets: [
            {
              label: "Training Hours",
              data: [8000, 18000, 28000, 38000, 50000, 62000],
              borderColor: "#10b981",
              backgroundColor: "rgba(16,185,129,0.08)",
              pointBackgroundColor: "#10b981",
              pointRadius: 5,
              fill: true,
              tension: 0.35,
              borderWidth: 2.5,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: { legend: { display: false } },
          scales: {
            x: {
              grid: { display: false },
              ticks: { color: "#9ca3af", font: { size: 11 } },
              border: { display: false },
            },
            y: {
              beginAtZero: true,
              grid: { color: "#f3f4f6" },
              ticks: {
                color: "#9ca3af",
                font: { size: 11 },
                callback: (v) => (v >= 1000 ? v / 1000 + "k" : v),
              },
              border: { display: false },
            },
          },
        },
      });
    },

    initRequirementsChart() {
      this.charts.requirements = new Chart(this.$refs.requirementsChart, {
        type: "bar",
        data: {
          labels: ["BSIT", "BSCS", "BSIS"],
          datasets: [
            {
              label: "Submitted",
              data: [72, 58, 65],
              backgroundColor: "#10b981",
              borderRadius: 4,
              barPercentage: 0.45,
            },
            {
              label: "Pending",
              data: [28, 42, 35],
              backgroundColor: "#e5e7eb",
              borderRadius: 4,
              barPercentage: 0.45,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              position: "bottom",
              labels: {
                usePointStyle: true,
                pointStyle: "circle",
                padding: 16,
                font: { size: 11 },
                color: "#6b7280",
              },
            },
          },
          scales: {
            x: {
              grid: { display: false },
              ticks: { color: "#9ca3af", font: { size: 11 } },
              border: { display: false },
            },
            y: {
              beginAtZero: true,
              max: 100,
              grid: { color: "#f3f4f6" },
              ticks: { color: "#9ca3af", font: { size: 11 } },
              border: { display: false },
            },
          },
        },
      });
    },

    initEvaluationChart() {
      this.charts.evaluation = new Chart(this.$refs.evaluationChart, {
        type: "bar",
        data: {
          labels: ["Technical Skills", "Communication", "Professionalism"],
          datasets: [
            {
              label: "Score",
              data: [4.2, 3.9, 4.5],
              backgroundColor: "#f59e0b",
              borderRadius: 4,
              barPercentage: 0.5,
            },
          ],
        },
        options: {
          indexAxis: "y",
          responsive: true,
          maintainAspectRatio: false,
          plugins: { legend: { display: false } },
          scales: {
            x: {
              beginAtZero: true,
              max: 5,
              grid: { color: "#f3f4f6" },
              ticks: { color: "#9ca3af", font: { size: 11 } },
              border: { display: false },
            },
            y: {
              grid: { display: false },
              ticks: { color: "#374151", font: { size: 11 } },
              border: { display: false },
            },
          },
        },
      });
    },

    async fetchRecentActivity() {
      this.activityLoading = true;
      try {
        const res = await this.axiosCall('/system-logs?page=1&limit=5', 'GET');
        if (res?.data?.data) this.recentActivity = res.data.data;
      } catch (e) {
        console.error('Failed to load recent activity', e);
      } finally {
        this.activityLoading = false;
      }
    },
    getActivityConfig(action) {
      const map = {
        USER_LOGIN:              { color: '#10b981', iconBg: '#d1fae5', icon: 'mdi-login',                   label: 'Login'      },
        USER_LOGOUT:             { color: '#6b7280', iconBg: '#f3f4f6', icon: 'mdi-logout',                  label: 'Logout'     },
        BATCH_CREATED:           { color: '#8b5cf6', iconBg: '#ede9fe', icon: 'mdi-layers-plus',             label: 'Batch'      },
        STUDENT_ENDORSED:        { color: '#3b82f6', iconBg: '#dbeafe', icon: 'mdi-account-arrow-right',     label: 'Endorsed'   },
        STUDENT_DEPLOYED:        { color: '#10b981', iconBg: '#d1fae5', icon: 'mdi-briefcase-check-outline', label: 'Deployed'   },
        STUDENT_PULLED_OUT:      { color: '#ef4444', iconBg: '#fee2e2', icon: 'mdi-account-minus-outline',   label: 'Pulled Out' },
        STUDENT_REASSIGNED:      { color: '#f59e0b', iconBg: '#fef3c7', icon: 'mdi-account-switch-outline',  label: 'Reassigned' },
        REQUIREMENT_SUBMITTED:   { color: '#3b82f6', iconBg: '#dbeafe', icon: 'mdi-file-upload-outline',     label: 'Submitted'  },
        REQUIREMENT_APPROVED:    { color: '#10b981', iconBg: '#d1fae5', icon: 'mdi-file-check-outline',      label: 'Approved'   },
        REQUIREMENT_DISAPPROVED: { color: '#ef4444', iconBg: '#fee2e2', icon: 'mdi-file-cancel-outline',     label: 'Returned'   },
        ATTENDANCE_SCANNED:      { color: '#06b6d4', iconBg: '#cffafe', icon: 'mdi-qrcode-scan',             label: 'Attendance' },
      };
      return map[action] || { color: '#6b7280', iconBg: '#f3f4f6', icon: 'mdi-information-outline', label: action };
    },
    getActivityColor(action) { return this.getActivityConfig(action).color; },
    getActivityIcon(action)  { return this.getActivityConfig(action).icon; },
    getActivityBadgeStyle(action) {
      const c = this.getActivityConfig(action);
      return { background: c.iconBg, border: `1px solid ${c.color}22` };
    },
    formatActivityTime(dateStr) {
      if (!dateStr) return '';
      const diff  = Date.now() - new Date(dateStr).getTime();
      const mins  = Math.floor(diff / 60000);
      const hours = Math.floor(diff / 3600000);
      const days  = Math.floor(diff / 86400000);
      if (mins  < 1)  return 'just now';
      if (mins  < 60) return `${mins}m ago`;
      if (hours < 24) return `${hours}h ago`;
      return `${days}d ago`;
    },
  },
};
</script>

<style scoped>
.coordinator-dashboard {
  min-height: 100vh;
}

/* ── Header ── */
.dash-page-title {
  font-size: 30px;
  font-weight: 800;
  color: #111827;
  letter-spacing: -0.5px;
  line-height: 1.2;
}

.dash-page-sub {
  font-size: 14px;
  color: #6b7280;
}

/* ── Stat Cards ── */
.stat-card {
  border: 1px solid transparent;
  transition: box-shadow 0.2s;
  height: 100%;
}
.stat-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.09);
}
.stat-card--amber  { background: #fffbeb; border-color: #fde68a; }
.stat-card--purple { background: #f5f3ff; border-color: #ddd6fe; }
.stat-card--green  { background: #ecfdf5; border-color: #a7f3d0; }
.stat-card--blue   { background: #eff6ff; border-color: #bfdbfe; }

.stat-icon-box {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.stat-icon-box--amber  { background: #fde68a; }
.stat-icon-box--purple { background: #ddd6fe; }
.stat-icon-box--green  { background: #a7f3d0; }
.stat-icon-box--blue   { background: #bfdbfe; }

.stat-number {
  font-size: 40px;
  font-weight: 800;
  line-height: 1.05;
  letter-spacing: -1.5px;
}
.stat-number--amber  { color: #d97706; }
.stat-number--purple { color: #7c3aed; }
.stat-number--green  { color: #059669; }
.stat-number--blue   { color: #2563eb; }

.stat-label {
  font-size: 13px;
  font-weight: 600;
  margin-top: 6px;
}
.stat-label--amber  { color: #d97706; }
.stat-label--purple { color: #7c3aed; }
.stat-label--green  { color: #059669; }
.stat-label--blue   { color: #2563eb; }

.stat-sub {
  font-size: 11.5px;
  color: #9ca3af;
  margin-top: 3px;
}

/* ── Dash Cards ── */
.dash-card {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.04);
}

.card-title {
  font-size: 15px;
  font-weight: 700;
  color: #111827;
}

.card-sub {
  font-size: 12.5px;
  color: #9ca3af;
}

/* ── Charts ── */
.chart-wrap {
  position: relative;
  width: 100%;
  height: 230px;
}

.chart-wrap--doughnut {
  height: 210px;
}

/* ── Quick Reports ── */
.view-all-link {
  font-size: 13px;
  color: #10b981;
  font-weight: 500;
  cursor: pointer;
  text-decoration: none;
}
.view-all-link:hover {
  text-decoration: underline;
}

.report-card {
  border: 1px solid #e5e7eb;
  cursor: pointer;
  transition: box-shadow 0.15s, border-color 0.15s;
  height: 100%;
}
.report-card:hover {
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.07);
  border-color: #d1fae5;
}
.report-card--active {
  background: #f0fdf4;
  border-color: #a7f3d0;
}

.report-title {
  font-size: 13.5px;
  font-weight: 700;
  color: #111827;
  margin-bottom: 3px;
}

.report-sub {
  font-size: 12px;
  color: #9ca3af;
}

/* ── Alerts ── */
.alert-icon-box {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.alert-title {
  font-size: 13.5px;
  font-weight: 700;
  color: #111827;
  margin-bottom: 2px;
}

.alert-desc {
  font-size: 12.5px;
  color: #6b7280;
  margin-bottom: 6px;
}

.alert-link {
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
}
.alert-link:hover {
  text-decoration: underline;
}

.activity-view-all-link { font-size: 13px; font-weight: 600; color: #10b981; text-decoration: none; }
.activity-view-all-link:hover { text-decoration: underline; }
.activity-item { transition: box-shadow 0.15s; }
.activity-icon-box { display: inline-flex; }
.activity-title { font-size: 13px; font-weight: 600; color: #111827; }
.activity-desc  { font-size: 12px; color: #6b7280; margin-top: 2px; }
.activity-time  { font-size: 11px; color: #9ca3af; margin-top: 4px; }
</style>
